<template>
  <div>
    <Header />
    <div class="content">
      <div class="w-1200 clearfix">
        <expertMembers />
        <router-view />
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import expertMembers from "../components/expertMembers";

export default {
  name: "Member",
  components: {
    Header,
    Footer,
    expertMembers
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.c-l {
  float: left;
  width: 268px;

  &-t {
    width: 268px;
    height: 328px;
    background: url("../assets/16.png");
    background-repeat: no-repart;
    background-size: cover;

    &-a {
      width: 117px;
      height: 117px;
      border-radius: 50%;
      margin-top: 30px;
    }
    &-s {
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      margin-top: 10px;
      width: 268px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        display: inline-block;
        float: left;
      }
    }
    &-g {
      //   display: flex;
      //   justify-content: center;
      //   align-items: center;
      color: #fff;
      font-size: 16px;
      width: 99px;
      height: 24px;
      background: linear-gradient(270deg, #e51725 0%, #730c13 100%);
      opacity: 1;
      border-radius: 12px 0px 12px 0px;
      margin: 0 auto;
      margin-top: 10px;
    }
    &-i {
      display: inline-block;
      float: left;
    }
    &-t {
      color: #ffffff;
      font-size: 14px;
      opacity: 0.6;
      margin-top: 10px;
    }
    &-b {
      width: 76px;
      height: 38px;
      background: rgba(255, 255, 255, 0.18);
      border: 1px solid #ffffff;
      opacity: 1;
      line-height: 38px;
      margin: 0 auto;
      color: #fff;
      margin-top: 10px;
      cursor: pointer;
    }
  }
  &-b {
    width: 268px;
    height: auto;
    background: #fff;
    border-radius: 6px;
    margin-top: 14px;
    padding-top: 14px;
    padding-bottom: 28px;
    &-item {
      height: 50px;
      text-align: center;
      line-height: 50px;
      color: #7c828a;
      font-size: 18px;
      span {
        padding-bottom: 12px;
        border-bottom: 1px double #d4dbdd;
        cursor: pointer;
      }
    }
  }
}
</style>
